// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__L-BW7","left":"Card_left__3xOPh","right":"Card_right__t3nDe"};